import {initComponent} from './core/init-component.js'
import {Swiper} from 'swiper'
import {Navigation} from 'swiper/modules'

initComponent('.js-product-recommendations-old', section => {
  const recommendationsUrl = section.dataset.url
  let swiper = null

  const initSwiper = () => {
    const slidesCount = section.querySelectorAll('.js-slide').length
    const slider = section.querySelector('.js-product-recommendations-old-swiper')
    const prevEl = section.querySelector('.js-slider-prev')
    const nextEl = section.querySelector('.js-slider-next')

    if (!slider || !prevEl || !nextEl) return

    return new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: slidesCount > 1 ? 1.345 : 1,
      spaceBetween: 8,
      slidesPerGroup: 1,
      slidesOffsetBefore: slidesCount > 1 ? 16 : 0,
      slidesOffsetAfter: slidesCount > 1 ? 16 : 0,
      navigation: {prevEl, nextEl},
      breakpoints: {
        768: {
          slidesPerView: slidesCount > 4 ? 4 : slidesCount,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 16,
        }
      }
    })
  }

  if (!recommendationsUrl) {
    swiper = initSwiper()
    return {
      unload() { swiper?.destroy() }
    }
  }

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return
    observer.unobserve(section)

    fetch(recommendationsUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.js-product-recommendations')
        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML
          swiper = initSwiper()
        }
      })
      .catch(console.error)
  }

  const intersectionObserver = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
  })

  intersectionObserver.observe(section)

  return {
    unload() {
      intersectionObserver.disconnect()
      swiper?.destroy()
    }
  }
})